<template>
  <div class="neilian">
    <iframe v-if="show" :src="url" style="height: 800px;width:1200px;margin:0 auto;" frameborder="0"></iframe>
  </div>
</template>

<script>
import { authChemicalDetail } from "@/api/oilBenzene";
export default {
  name: "relatedProducts",
  data() {
    return {
      show: false,
      url:'http://groupapp.risun.com:9003/ZBZHReport/ReportServer?reportlet=chemical_use.cpt&op=view'
    }
  },
  created() {
    this.showPage();
  },
  methods: {
    showPage() {
      authChemicalDetail().then((res) => {
        if (res.msg) {
          this.show = true;
        }
      });
    }
  } 
}
</script>

<style scoped>
.neilian {
  height: 800px;
  width: 1200px;
  margin: 30px auto;
  text-align: center;
}
</style>
